import React,{useState,useEffect,useRef,useCallback} from 'react';
// comps
import ProfileInfoPart from '../comps/profileInfoPart'
import UserOptions from '../comps/useroptions'
import FriendPart from '../comps/friendPart'
import MainBody from '../comps/mainBody'
import Payment2 from '../comps/payment2'
import ToolPart from '../comps/toolPart'
import Headerphoto from '../comps/headerphoto'
import {useSelector,useDispatch} from 'react-redux'
import * as actions from '../data/posts_data'
import PostEditModal from '../comps/postEditModal'
// all kind of data
import * as action2 from '../data/history_data'
import * as action from '../store/actions'
import * as authAction from '../store/authAction'
import {useNavigate} from 'react-router-dom';
import '../styles/home.css';
import StoryViewer from '../comps/storyViewer'
import {Helmet} from "react-helmet";
import { hasStory, storyMsLeft } from '../utils/story'
import { useCreateUpload } from '../hooks/useCreateUpload'
import { profileTabForUpload } from '../utils/createUpload'
const Home = props => {
  const [isStory,setStory] = useState(false);
  const navigate = useNavigate();
  const[isload,SetLoad] = useState(true);
  const [error,setError] = useState('');
  const dispatch = useDispatch();
  const [isvideo,setVideo] = useState();
  const [manageMode, setManageMode] = useState(false);
  const [editPost, setEditPost] = useState(null);


useEffect(() => {
  const userData = localStorage.getItem('userdata');
  if (!userData) {
    navigate('/auth');
    return undefined;
  }
  const loadProfile = async () => {
    const { id, pid } = JSON.parse(userData);
    try {
      await dispatch(authAction.auth(id, pid));
    } catch (err) {
      setError(err.message || 'Could not load profile');
    }
    SetLoad(true);
    try {
      await dispatch(actions.get_my_posts());
    } catch (err) {
      setError(err.message || 'Could not load your posts');
    }
    try {
      await dispatch(actions.get_posts(0, 5));
    } catch (_) {}
    SetLoad(false);
  };
  loadProfile();
  return undefined;
}, [dispatch, navigate]);

  
const [page,setpage] = useState(5);
  const pageRef = useRef(5);
  const loadingMore = useRef(false);
  const getData2 = useCallback(async () => {
    if (loadingMore.current) return
    loadingMore.current = true
    try {
      const added = await dispatch(actions.get_postss(pageRef.current, 8))
      pageRef.current += 8
      setpage(pageRef.current)
      return added || { longs: 0, shorts: 0 }
    } catch (err) {
      setError(err.message)
      return { longs: 0, shorts: 0 }
    } finally {
      loadingMore.current = false
    }
  }, [dispatch])



  const[isType,setType] = useState('i');
  const uploadJob = useCreateUpload();
  const switchedTab = useRef(false);

  useEffect(() => {
    if (!uploadJob) {
      switchedTab.current = false
      return undefined
    }
    if (switchedTab.current) return undefined
    if (uploadJob.status === 'uploading' || uploadJob.status === 'publishing') {
      setType(profileTabForUpload(uploadJob.type))
      switchedTab.current = true
    }
    return undefined
  }, [uploadJob])

  const list = useSelector(state => state.PostReducer.userPosts);
  const list2 = useSelector(state => state.PostReducer.history);
  const userlist = useSelector(state => state.authReduse);
  const id = useSelector(state => state.authReduse.id)
  const translations = useSelector(state => state.lang_reduse.lang)

  useEffect(() => {
    const story = userlist?.story
    if (!story) return undefined
    if (!hasStory(story)) {
      dispatch(authAction.update_story(''))
      return undefined
    }
    const timer = window.setTimeout(() => {
      dispatch(authAction.update_story(''))
    }, storyMsLeft(story) + 250)
    return () => window.clearTimeout(timer)
  }, [dispatch, userlist.story])

  const emptyTitle = isType === 'h'
    ? translations.thereisnohistory
    : isType === 'i'
      ? translations.thereisnophotos
      : isType === 's'
        ? translations.thereisnoshorts
        : translations.thereisnovideos

  const savePostOrder = useCallback(async (ids) => {
    try {
      await dispatch(action.reorder_posts(ids));
    } catch (err) {
      setError(err.message);
    }
  }, [dispatch]);


  return(
  <section className='homePage HomePage'>
    <Helmet>
  
    <meta name="theme-color" content="#E8E9EB" />
   
    <title>pinweelo</title>
  <meta name="description" content='here you can watch best short and long video and create profile '/>
<meta name='keywords' content='watch,pinweelo website,share,post,main'/>
 <link rel="canonical" href="https://pinweelo.com/" />
    </Helmet>
    <FriendPart />
<Headerphoto
  name={userlist.name}
  img={userlist.big_img}
  title={manageMode ? 'Done' : 'Edit'}
  titleActive={manageMode}
  onTitleClick={() => setManageMode(prev => !prev)}
/>
    <StoryViewer
      open={isStory}
      onClose={() => setStory(false)}
      media={userlist.story}
      name={userlist.email || userlist.name}
      photo={userlist.photo}
      canAdd
    />
<div className='ProfileInfoWithOptions'>
  <ProfileInfoPart postsCount={list?.length} click1={()=> navigate('/following')} click2={()=> navigate('/followers')} story={()=>setStory(true)} userlist={userlist} />
</div>
  <UserOptions home={true} setType={setType} isType={isType} />
<MainBody
  embedded
  page={page}
  fetchData={getData2}
  historyDelete={(id) =>dispatch(action.delete_history(id))}
  error={error}
  isload={isload}
  list={isType === 'h'?list2:list}
  type={isType}
  emptyTitle={emptyTitle}
  manageMode={manageMode && isType !== 'h'}
  onEditPost={(item) => setEditPost(item)}
  onDeletePost={async (item) => {
    if (!window.confirm(`Delete “${item.title || 'this post'}”?`)) return;
    try {
      await dispatch(action.delete_post(item.id));
    } catch (err) {
      setError(err.message);
    }
  }}
  onReorderPosts={savePostOrder}
/>
{editPost && (
  <PostEditModal
    post={editPost}
    onClose={() => setEditPost(null)}
    onSave={async (next) => {
      await dispatch(action.update_post(next));
      setEditPost(null);
    }}
  />
)}

  </section>
  )
}
export default Home;
